<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" [class.active]="checked"
	 width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
<circle fill="#00A7E1" stroke="#00A7E1" stroke-miterlimit="9" cx="10" cy="10" r="9" class="wrapper" />
<circle fill="#FFFFFF" stroke="#FFFFFF" stroke-miterlimit="10" cx="10" cy="10" r="4" class="checked"/>
</svg>

<span><ng-content></ng-content></span>
